import { render, staticRenderFns } from "./ClientesXFechaCorte.vue?vue&type=template&id=03c6f6ec&scoped=true"
import script from "./ClientesXFechaCorte.vue?vue&type=script&lang=js"
export * from "./ClientesXFechaCorte.vue?vue&type=script&lang=js"
import style0 from "./ClientesXFechaCorte.vue?vue&type=style&index=0&id=03c6f6ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c6f6ec",
  null
  
)

export default component.exports